import { styled } from '@mui/material';
import React from 'react'

const QuestionHeadingNew = (props:{children:React.ReactNode,type?:string, disableTextTransform?: boolean}) => {
  const {children}=props;
  const Wrapper= styled('div')(`
    font-size:15px;
    text-align:left;
    padding-left:0.2rem;
    font-weight:500;
  margin-bottom: ${ props.type === "toggle" ? "0px" : "8px"};
    text-transform: ${props.disableTextTransform? "none" : "lowercase"};
    &::first-letter {
    text-transform:${props.disableTextTransform? "none" : "capitalize"};
    }
  `)
  return (
    <Wrapper>
        {children}
    </Wrapper>
  )
}

export default QuestionHeadingNew